import gql from 'graphql-tag'

export const GET_WORKING_HOUR_HISTORY = gql`
  query GetWorkingHourHistory {
    getWorkingHourHistory {
      id
      effectiveFrom
      week {
        dayOfWeek
        isClosed
        isOpen24Hours
        slots {
          openTime
          closeTime
        }
      }
    }
  }
`

export const GET_WORKING_HOURS = gql`
  query GetWorkingHours {
    getWorkingHours {
      id
      dayOfWeek
      isClosed
      isOpen24Hours
      slots {
        openTime
        closeTime
      }
    }
  }
`
